import React from "react";
import samu from "../img/ambulance.svg";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, info: "", showError: false };
  }

  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({
      hasError: true,
      error: error.message
    });
    // You can also log the error to an error reporting service
    //logErrorToMyService(error, info);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="container">
          <section className="hero is-fullheight ">
            <div className="hero-body">
              <div className="container has-text-centered">
                <h1 className="title">ERREUR</h1>
                <h2 className="subtitle">Une erreur est survenue!</h2>

                <figure className="image is-128x128 margin-auto">
                  <img alt="samu" src={samu} />
                </figure>
                <br />
                <p>
                  Si cette erreur persiste veuillez contacter un responsable!
                </p>
                <p>
                  {" "}
                  {!this.state.showError && (
                    <a onClick={() => this.setState({ showError: true })}>
                      Afficher erreur →
                    </a>
                  )}
                  {this.state.showError && (
                    <pre>
                      <code>{this.state.error}</code>
                    </pre>
                  )}
                </p>
              </div>
            </div>
          </section>
        </div>
      );
    }
    return this.props.children;
  }
}



// WEBPACK FOOTER //
// ./src/components/ErrorBoundary.js